import * as React from 'react';
import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/1991-Breast-Screening.jpg');

const BreastScreeningContent = () => {
    return (
        <>
            <TimelineVideo videoId="ydDBd0i-GPk" imagePreview={VideoPreview} />
            <h4>
                Free breast screening starts in Australia for women aged 50-74 years  
            </h4>
        </>
    );
}

export default BreastScreeningContent;